export default "__VITE_PUBLIC_ASSET__88248443__"